import { SurveyForm } from 'ui/components/company/patterns/SurveyForm/SurveyForm';

/**
 * 売り手アンケートフォーム
 */
export const CompanySurveyForm: React.FC = () => {
    return <SurveyForm />;
};
